import { Controller } from "@hotwired/stimulus"

/* The public nav is white-on-transparent, which disappears over the one light
 * section on the page. While that section passes beneath the header, this puts
 * the nav's frosted dark panel back — the same panel the scroll-driven
 * nav-frost animation uses, minus the scroll-timeline support requirement.
 */
export default class extends Controller {
  static values = { navSelector: { type: String, default: ".public-nav" } }

  connect() {
    this._nav = document.querySelector(this.navSelectorValue)
    if (!this._nav) return
    this._onResize = this._onResize.bind(this)
    window.addEventListener("resize", this._onResize, { passive: true })
    this._observe()
  }

  disconnect() {
    window.removeEventListener("resize", this._onResize)
    if (this._observer) this._observer.disconnect()
    if (this._nav) this._nav.classList.remove("is-over-light")
  }

  /* Shrinking the observation window to the height of the header leaves an
   * intersection that means exactly "this section is behind the nav".
   */
  _observe() {
    if (this._observer) this._observer.disconnect()
    const bottomInset = Math.max(0, window.innerHeight - this._nav.offsetHeight)
    this._observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => this._nav.classList.toggle("is-over-light", entry.isIntersecting)),
      { rootMargin: `0px 0px -${bottomInset}px 0px` }
    )
    this._observer.observe(this.element)
  }

  _onResize() {
    this._observe()
  }
}
